import { render } from "./SaveNoteDialog.vue?vue&type=template&id=5327840a&scoped=true"
import script from "./SaveNoteDialog.vue?vue&type=script&lang=js"
export * from "./SaveNoteDialog.vue?vue&type=script&lang=js"

import "./SaveNoteDialog.vue?vue&type=style&index=0&id=5327840a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5327840a"]])

export default __exports__